/*
 * Copyright (c) University of Technology Sydney. All rights reserved.
 * See LICENSE file in the project root for full license information.
 *
 * Project Name: wpt-frontend.
 * Author: Michael Diponio
 * Created: 04/05/2022
 */

import * as React from 'react';
import { Row, ValueCell } from '@/wpt-lib/pdf/common/Table';

const Career = ({
    goalSummary,
    stepsToAchieve,
    careerStatement,
}: Partial<{
    goalSummary: string;
    stepsToAchieve: string;
    careerStatement: string;
}>) => (
    <>
        <Row>
            <ValueCell label="Goal Summary" value={goalSummary} />
        </Row>
        {careerStatement && (
            <Row>
                <ValueCell label="Career Statement" value={careerStatement} />
            </Row>
        )}
        <Row>
            <ValueCell label="Planned Steps to Achieve this Goal" value={stepsToAchieve} />
        </Row>
    </>
);

export default Career;
